module.exports = __webpack_public_path__ + "img/AI.4c9a7bdc.png";